import type { ApplicationsContract } from '@terra/shared-contracts-applications';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const applicationDocumentationApi = {
  updateDocumentationUrls: ({
    applicationId,
    documentationUrls,
  }: {
    applicationId: string;
    documentationUrls: string[];
  }) =>
    tenantAwareApiWrapper<typeof ApplicationsContract.updateApplication>({
      endpointFn: (headers) =>
        applicationsClient.updateApplication({
          params: { id: applicationId },
          body: { documentationUrls },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  deleteApplicationFile: ({
    applicationId,
    fileId,
  }: {
    applicationId: string;
    fileId: string;
  }) =>
    tenantAwareApiWrapper<typeof ApplicationsContract.deleteApplicationFile>({
      endpointFn: (headers) =>
        applicationsClient.deleteApplicationFile({
          params: { id: applicationId, fileId },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),

  getApplicationFileDownloadUrl: ({
    applicationId,
    fileId,
  }: {
    applicationId: string;
    fileId: string;
  }) =>
    tenantAwareApiWrapper<
      typeof ApplicationsContract.getApplicationFileDownloadUrl
    >({
      endpointFn: (headers) =>
        applicationsClient.getApplicationFileDownloadUrl({
          params: { id: applicationId, fileId },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
